// extracted by mini-css-extract-plugin
export default {"button-inline":"button-inline__button-inline--UpV4o","buttonInline":"button-inline__button-inline--UpV4o"};